const ADDRESS_FIELDS = [
  'cep',
  'logradouro',
  'numero',
  'cidade',
  'estado',
  'bairro',
];

const required = (profile, fields, t) =>
  fields.reduce((errors, field) => {
    if (!String(profile[field] || '').trim()) {
      errors[field] = t('SALES_PROPERTY.COMMON.REQUIRED');
    }
    return errors;
  }, {});

const invalidLaudemio = profile =>
  (Array.isArray(profile.laudemios) ? profile.laudemios : []).some(
    item =>
      !item.tipo_laudemio ||
      (item.tipo_laudemio !== '2' && !item.valor_laudemio)
  );

export const sectionErrors = ({ profile, property, section, t }) => {
  if (section === 'identity') return required(profile, ['codigo'], t);
  if (section === 'address') return required(profile, ADDRESS_FIELDS, t);
  if (section === 'registry') {
    return required(
      profile,
      ['escritura', 'matricula', 'inscricaoMunicipal', 'rgi'],
      t
    );
  }
  if (section === 'laudemio') {
    return invalidLaudemio(profile)
      ? { laudemios: t('SALES_PROPERTY.COMMON.REQUIRED') }
      : {};
  }
  if (section === 'values') {
    const errors = required(
      profile,
      ['valorAnunciado', 'valorVenda', 'valorSinal'],
      t
    );
    if (!profile.forma_pagamento?.length) {
      errors.forma_pagamento = t('SALES_PROPERTY.VALUES.PAYMENT_REQUIRED');
    }
    return errors;
  }
  if (section === 'deadline') return required(profile, ['prazo'], t);
  if (section === 'clauses') return required(profile, ['clausula_segunda'], t);
  if (
    section === 'documents' &&
    !property.documents?.registry_document_present
  ) {
    return { documents: t('SALES_PROPERTY.DOCUMENTS.REQUIRED') };
  }
  return {};
};
